module.exports = __webpack_public_path__ + "img/photo-flow5.38b1a983.png";